import { createContext } from 'react';
import { ExpandedContent } from '../types/expanded.types';

export const ExpandedContext = createContext<ExpandedContent>({
	isOpen: false,
	setIsOpen: () => {},
});
